/**
 * Mobile menu
 */

function toggleMenuOpen() {
    const menu = document.querySelector('.header__menu-popup');
    if (menu) {
        menu.classList.add('open');
    }
}

document.querySelectorAll('.hamburger').forEach(button => {
    button.addEventListener('click', toggleMenuOpen);
});

function closeMobileMenu() {
    const menu = document.querySelector('.header__menu-popup');
    if (menu && menu.classList.contains('open')) {
        menu.classList.remove('open');
    }
}

document.querySelector('.popup-close').addEventListener('click', closeMobileMenu);
